export const myCommissionsColumns = [
  1.0, 1.25, 1.5, 1.75, 2.0, 2.25, 2.5, 2.75,
];

export const tableHeaderName = [
  "My Commission is",
//   "Conv 30",
//   "FHA  30",
//   "VA  30",
//   "USDA  30",
"CONVENTIONAL",
"GOVERNMENT",
];

export const tableHeaderConv = [  "CONVENTIONAL" ]
export const tableHeaderFha = [  "GOVERNMENT" ]


export const addHundred = [
  101, 101.25, 101.5, 101.75, 102, 102.25, 102.5, 102.75,103
];

export const PAR_BASIS = 0.5;

export const tableFormat = [
//  { "my_Commission_is": [ 1.0, 1.25, 1.5, 1.75, 2.0, 2.25, 2.5, 2.75,3.0]}, /** SWP-45: remove ,3.25, i.e , above 3.00 */
{ "my_Commission_is": [ 1.5,3.0]},
 { "Conventional_30_Year": []},
  {"FHA_30_Year": []},
  {"VA_30_Year": []},
  {"USDA_30_Year": []},
]

export const videoIdArray = 
[
  {
  id: '-jDjGlbUNHk' //1
},
{
   id: '7SRmEDQ5M8s' //2
},
{
   id: 'pAzzdHQdHcE' //3
},
{
   id: 'TJY19XOuX-o' //4
},
{
   id: 'oSNCtsolAOA' //5
},
{  
   id: 'LIuGwz1MN8U' //6
},
{
   id: 'Afm0oo3iWwg' //7
},
{
   id: 'TPYTVIdx2qw' //8
},
{
   id: 'ZixZ_xI1-rU' //9
},
{
   id: '0VTrn4Q_Jpc' //10
},
{
   id: 'sctghfzmHE8' //11
},
{
   id: 'cz6ok6BJCDo' //12
},
{
   id: 'GN8jvXiak1U' //13
},
{
   id: '_KtyxtkA8Ss' //14
},
{
   id: 'd5ob-9_WbfU' //15
},
{
   id: 'CRFffjNZ_Xw' //16
},
{ // pending
   id: '3WgQLqc95h0' //17
},
{
   id: 'y53IdKsPtZM' //18
},
{
   id: 'NYBJjg9_qIg' //19
},
{
   id: 'f19aZIIelE4' //20
},
{
   id: 'HFKAJdKk7H8' //21
},
{
   id: 'f52MxiH0ktE' //22
},
{
   id: '_HLrIGhaXVg' //23
},
{
   id: 'I08qYM0KnFM' //26
},
{
   id: 'awleOacG_8c' //27
},
{
   id: 'qVU7_rbdkYE' //28
},
{
   id: 'NIDrwtOMb3Y' //29
},
{
   id: 'Gn09PXSrvT0' //30
},
{
 id: 'v8RrmD16VVA' //31
},

]

export const imagePath = 'https://d2w24n4g34usfg.cloudfront.net/wholesale-websites'
export const generateYtThumbnail = (idPassed) => `https://d2w24n4g34usfg.cloudfront.net/SunWestPartners/images/video-thumbnails/${idPassed}.jpg`

export const generateYtVideoLink = (idPassed) => `https://www.youtube.com/watch?v=${idPassed}&authuser=0`

export const dragElement = (elmnt, holderEle) => { // (myDIv, myDiveader is holding element for this for this)
  // console.log('DragFn:', elmnt)
  var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
  if (document.getElementById(elmnt.id + "header")) {
      /* if present, the header is where you move the DIV from:*/
      document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
  } else if (holderEle && holderEle.length > 0) {
      /* if present, the header is where you move the DIV from:*/
      holderEle[0].onmousedown = dragMouseDown;
  } else {
      /* otherwise, move the DIV from anywhere inside the DIV:*/
      elmnt.onmousedown = dragMouseDown;
  }

  function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
  }

  function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
  }

  function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
  }
}
